// extracted by mini-css-extract-plugin
export default {"wrapper":"searchableListFooter__wrapper-ky08F"};